import React, { useEffect, useState } from 'react'
import { BiChevronLeft, BiChevronRight } from 'react-icons/bi'
import { MdVerifiedUser, MdLocalShipping, MdShoppingCartCheckout, MdSupportAgent, MdWorkspacePremium } from 'react-icons/md';
import { Link } from 'react-router-dom'

function Carousel() {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [isPaused, setIsPaused] = useState(false);

    const slides = [
        {
            icon: MdVerifiedUser,
            title: 'Secure & Trusted',
            highlight: 'Payments',
            description: 'Shop with confidence using our encrypted payment gateway. Your data is protected with industry-leading security.',
        },
        {
            icon: MdLocalShipping,
            title: 'Fast & Reliable',
            highlight: 'Delivery',
            description: 'Get your orders delivered quickly and safely. Track your package in real-time from warehouse to doorstep.',
        },
        {
            icon: MdShoppingCartCheckout,
            title: 'Simple, Secure',
            highlight: 'Checkout',
            description: 'Seamless checkout experience with multiple payment options. Complete your purchase in just a few clicks.',
        },
        {
            icon: MdSupportAgent,
            title: '24/7 Customer',
            highlight: 'Support',
            description: 'Our dedicated team is always ready to help. Get assistance anytime via chat, email, or phone.',
        },
        {
            icon: MdWorkspacePremium,
            title: 'Quality You Can',
            highlight: 'Trust',
            description: 'Every product is carefully selected and quality-tested. We stand behind everything we sell.',
        }
    ];

    const slideLabels = [
        'Secure & Trusted Payments',
        'Fast & Reliable Delivery',
        'Simple, Secure Checkout',
        '24/7 Customer Support',
        'Quality You Can Trust'
    ];

    const nextSlide = () => {
        setCurrentSlide((prev) => (prev + 1) % slides.length);
    };

    const prevSlide = () => {
        setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
    };

    const goToSlide = (index) => {
        setCurrentSlide(index);
    };

    const handleManualNavigation = (action) => {
        setIsPaused(true);
        action();

        setTimeout(() => {
            setIsPaused(false);
        }, 10000);
    };

    useEffect(() => {
        if (isPaused) return;

        const interval = setInterval(nextSlide, 5000);
        return () => clearInterval(interval);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isPaused, currentSlide]);

    return (
        <section className="relative bg-background-dark py-8 md:py-12 mb-6">
            <div className="container mx-auto px-4">
                <div className="relative rounded-2xl overflow-hidden shadow-2xl h-[350px] md:h-[450px]">

                    {slides.map((slide, index) => (
                        <div
                            key={index}
                            className={`absolute inset-0 transition-all duration-700 ease-in-out ${index === currentSlide
                                ? 'opacity-100 translate-x-0'
                                : index < currentSlide
                                    ? 'opacity-0 -translate-x-full'
                                    : 'opacity-0 translate-x-full'
                                }`}
                        >
                            <div className="h-full flex items-center bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900">
                                <div className="absolute inset-0 bg-gradient-to-r from-black/50 to-transparent"></div>
                                <div className="relative z-10 px-6 md:px-16 w-full md:w-2/3">
                                    <div className="flex items-center justify-between space-x-3 md:space-x-4 mb-3 md:mb-4 w-full">
                                        <div className="flex items-center space-x-3 md:space-x-4 mb-3 md:mb-4">
                                            <slide.icon className="text-secondary text-4xl md:text-5xl" />
                                            <div className="h-1 w-8 md:w-12 bg-secondary rounded-full"></div>
                                        </div>
                                        {index % 2 === 0 && (
                                            <div className="md:hidden">
                                                <Link
                                                    className="bg-primary hover:bg-red-700 text-white font-bold py-2.5 md:py-3 px-6 md:px-8 rounded-full transition-all transform hover:scale-105 uppercase tracking-wider text-sm md:text-base"
                                                    to="/products"
                                                >
                                                    Shop Now
                                                </Link>
                                            </div>
                                        )}
                                    </div>
                                    <h2 className="text-3xl md:text-6xl font-black text-white leading-tight uppercase">
                                        {slide.title} <br />
                                        <span className="text-secondary">{slide.highlight}</span>
                                    </h2>
                                    <p className="mt-4 md:mt-6 text-base md:text-xl text-gray-300 max-w-lg leading-relaxed">
                                        {slide.description}
                                    </p>
                                    {index % 2 === 0 && (
                                        <div className="hidden lg:block mt-8">
                                            <Link
                                                className="bg-primary hover:bg-red-700 text-white font-bold py-2.5 md:py-3 px-6 md:px-8 rounded-full transition-all transform hover:scale-105 uppercase tracking-wider text-sm md:text-base"
                                                to="/products"
                                            >
                                                Shop Now
                                            </Link>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}


                    <button
                        onClick={() => handleManualNavigation(prevSlide)}
                        className="absolute left-2 md:left-4 top-1/2 -translate-y-1/2 bg-white/10 hover:bg-primary text-secondary p-2 md:p-3 rounded-full backdrop-blur-md transition-all z-20"
                    >
                        <BiChevronLeft className="text-2xl md:text-3xl" />
                    </button>


                    <button
                        onClick={() => handleManualNavigation(nextSlide)}
                        className="absolute right-2 md:right-4 top-1/2 -translate-y-1/2 bg-white/10 hover:bg-primary text-secondary p-2 md:p-3 rounded-full backdrop-blur-md transition-all z-20"
                    >
                        <BiChevronRight className="text-2xl md:text-3xl" />
                    </button>


                    <div className="absolute bottom-4 md:bottom-6 left-1/2 -translate-x-1/2 flex space-x-2 md:space-x-3 z-20">
                        {slides.map((_, index) => (
                            <button
                                key={index}
                                onClick={() => handleManualNavigation(() => goToSlide(index))}
                                className={`h-2 rounded-full transition-all ${index === currentSlide
                                    ? 'w-8 md:w-12 bg-secondary'
                                    : 'w-2 md:w-3 bg-white/30 hover:bg-white/50'
                                    }`}
                            ></button>
                        ))}
                    </div>
                </div>

                <div className="hidden lg:grid grid-cols-5 gap-4 mt-8">
                    {slideLabels.map((label, index) => (
                        <button
                            key={index}
                            onClick={() => handleManualNavigation(() => goToSlide(index))}
                            className={`p-4 border-b-4 rounded-t-lg transition-colors ${index === currentSlide
                                ? 'border-secondary bg-white/5 backdrop-blur-sm'
                                : 'border-transparent hover:border-gray-500'
                                }`}
                        >
                            <p className={`text-xs font-bold uppercase mb-1 ${index === currentSlide ? 'text-secondary' : 'text-gray-500'
                                }`}>
                                {String(index + 1).padStart(2, '0')}
                            </p>
                            <p className={`text-sm font-bold ${index === currentSlide ? 'text-white' : 'text-gray-400'
                                }`}>
                                {label}
                            </p>
                        </button>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Carousel